import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	hiddenByFilterTitle: {
		id: 'portfolio-3-portfolio.app-simple-plans.flag-group.issue-search-warning-flag.hidden-by-filter-title',
		defaultMessage: 'Matching results currently not visible',
		description: 'Title for warning when some issues are hidden behind filter',
	},
});
